<!-- 部门操作 -->
<template>
  <div class="store-modal-content">
    <div class="data_action_form">
      <el-card
        class="box-card"
        body-style="padding:0;border:1px solid #E4E7ED"
        v-if="formDataList"
      >
        <v-tabs
          :type="dataActionBox.actionType"
          :activeName="showTabs"
          :name="'jciName'"
          :value="'jciName'"
          :tabslist="formDataList"
          @tabs="
            (val) => {
              showTabs = val
            }
          "
        >
          <template slot="tabs" slot-scope="scope">
            <div class="table_content_box">
              <!-- 主信息 -->
              <div v-if="scope.index == 0">
                <el-form
                  size="mini"
                  inline
                  :model="sendDataInfo"
                  label-width="150px"
                  ref="sendDataInfo"
                  :show-message="false"
                >
                  <!-- <el-form-item
                    label="卡类型编号"
                    prop="capCode"
                    :rules="[{ required: true, trigger: ['blur', 'change'] }]"
                  >
                    <label
                      slot="label"
                      :style="$common.labelStyle('卡类型编号')"
                      v-html="$common.htmlLabel('卡类型编号')"
                    ></label>
                    <el-input
                      class="form_codition"
                      v-model.trim="sendDataInfo.capCode"
                      :maxlength="$store.state.inputLength"
                      placeholder="填写卡类型编号"
                    ></el-input>
                  </el-form-item> -->
                  <el-form-item label="卡类型名称" prop="capName">
                    <label
                      slot="label"
                      :style="$common.labelStyle('卡类型名称')"
                      v-html="$common.htmlLabel('卡类型名称')"
                    ></label>
                    <el-input
                      class="form_codition"
                      v-model.trim="sendDataInfo.capName"
                      :maxlength="$store.state.inputLength"
                      placeholder="填写卡类型名称"
                    ></el-input>
                  </el-form-item>

                  <!-- <el-form-item label="扣率" prop="discount">
                    <label
                      slot="label"
                      :style="$common.labelStyle('扣率')"
                      v-html="$common.htmlLabel('扣率')"
                    ></label>
                    <el-input
                      class="form_codition"
                      v-model.trim="sendDataInfo.discount"
                      :maxlength="$store.state.inputLength"
                      :min="0"
                      type="number"
                      placeholder="填写扣率"
                    ></el-input>
                  </el-form-item> -->
                  <div>
                    <!-- <el-form-item label="是否折扣" prop="isDiscont">
                    <el-radio-group v-model="sendDataInfo.isDiscont" size="mini">
                          <el-radio-button label="0">否</el-radio-button>
                          <el-radio-button label="1">是</el-radio-button>
                        </el-radio-group> 
                  </el-form-item> -->
                  <el-form-item label="是否会员价" prop="isMeprice">
                    <el-radio-group v-model="sendDataInfo.isMeprice" size="mini">
                          <el-radio-button label="0">否</el-radio-button>
                          <el-radio-button label="1">是</el-radio-button>
                        </el-radio-group> 
                  </el-form-item>
                  <el-form-item label="是否使用密码" prop="isPwd">
                    <el-radio-group v-model="sendDataInfo.isPwd" size="mini">
                          <el-radio-button label="0">否</el-radio-button>
                          <el-radio-button label="1">是</el-radio-button>
                        </el-radio-group> 
                  </el-form-item>
                  <el-form-item label="是否储值" prop="isStored">
                    <el-radio-group v-model="sendDataInfo.isStored" size="mini">
                          <el-radio-button label="0">否</el-radio-button>
                          <el-radio-button label="1">是</el-radio-button>
                        </el-radio-group> 
                  </el-form-item>
                  </div>
                  
         
                
                </el-form>
              </div>
            </div>
          </template>
        </v-tabs>
      </el-card>
    </div>
    <div class="dialog-footer">
      <el-button @click="drawerCancel">取 消</el-button>
      <el-button type="primary" @click="sendDataAction()">保 存</el-button>
    </div>
 
    
    
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  props: ["actionData"],
  name: "memCardModal",
  //import引入的组件需要注入到对象中才能使用
  components: {

  },
  data() {
    //这里存放数据
    return {
      dataActionBox: {
        actionType: 0, // 0新增，1修改
      },
      sendDataInfo: {
        coId: "",
        coName: "",
        capName: "",
        discount: "",
        isDiscont: 0,
        isMeprice: 0,
        isPwd: 0,
        isStored: 0,

      },
      formDataList: [],
      showTabs: "",
      allDepartmentList: [],
      selectDepartmentPath: [],

     

     
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    initActionBox() {
      for (let key in this.sendDataInfo) {
        this.sendDataInfo[key] = ""
      }

      this.sendDataInfo.storeId = 0
      this.selectDepartmentPath = -1

      this.dataActionBox.actionType = 0
    },

    async openBox() {
      // this.initActionBox()

      if (this.actionData.cate == 0) {
        this.showTabs = "新增会员卡类型"
        this.formDataList = [
          {
            jciName: "新增会员卡类型",
            jurconfigform: [],
          },
        ]
      } else {
        this.dataActionBox.boxTitle = "编辑会员卡类型" 
        this.dataActionBox.openMode = "ltr"
        // 回显数据
        if (this.actionData.oldData) {
          for (let key in this.actionData.oldData) {
            // 特殊处理会员日类型
            if (key === "memDayType") {
              this.$set(
                this.sendDataInfo,
                key,
                this.actionData.oldData[key].toString()
              )
            } else {
              this.$set(this.sendDataInfo, key, this.actionData.oldData[key])
            }
          }
          // 处理会员日数据
          if (this.actionData.oldData.memDay) {
            this.memDayIds = this.actionData.oldData.memDay
              .split(",")
              .map(Number)
            // 设置会员日名称
            if (this.actionData.oldData.memDayName) {
              this.obj.memDayValues = this.actionData.oldData.memDayName
            }
            this.getMemDays() // 获取会员日数据
          }
          // 处理经营范围数据
          if (this.actionData.oldData.storeManrange) {
            this.smManrangeIds =
              this.actionData.oldData.storeManrange.split(",")
            // 设置经营范围名称
            if (this.actionData.oldData.storeManrangeName) {
              this.obj.smManrangeValues =
                this.actionData.oldData.storeManrangeName
            }
            this.getRanges() // 获取经营范围数据
          }
          // 处理库房信息
          if (this.actionData.oldData.stId) {
            this.sendDataInfo.stId = this.actionData.oldData.stId
            this.sendDataInfo.stName = this.actionData.oldData.stName
          }
        }

        this.formDataList = [
          {
            jciName: "编辑会员卡类型", 
            jurconfigform: [],
          },
        ]
        this.showTabs = "编辑会员卡类型"
      }

      this.dataActionBox.actionType = this.actionData.cate
    },

    async sendDataAction() {
      // 表单验证
      this.$refs.sendDataInfo.validate(async (valid) => {
        if (valid) {
       
          let sendData = JSON.parse(JSON.stringify(this.sendDataInfo))
   

          try {
            let responseData
            // 如果是新增
            if (this.dataActionBox.actionType == 0) {
              responseData = await this.$http.addCardType(sendData)
            }
            // 如果是编辑
            else if (this.dataActionBox.actionType == 1) {
              responseData = await this.$http.updateCardType(sendData)
            }

            if (responseData.status == 200) {
              this.$message({
                message:
                  this.dataActionBox.actionType == 0 ? "新增成功" : "编辑成功",
                type: "success",
              })
              this.$emit("drawerCancel", false)
              this.$emit("toDetail", responseData.result)
            } else {
              this.$message({
                message: responseData.message,
                type: "error",
              })
            }
          } catch (error) {
            console.error("error", error)
            this.$message({
              message: "操作失败",
              type: "error",
            })
          }
        } else {
          this.$message({
            message: "请填写必填项",
            type: "error",
          })
          return false
        }
      })
    },

 
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(",")
      arr.forEach((item) => {
        this.sendDataInfo[item] = val[item]
      })
    },


 
   
 
    drawerCancel() {
      this.$confirm("确认关闭弹窗吗？未保存的数据将丢失。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$emit("drawerCancel", false)
        })
        .catch(() => {})
    },
   
   

    
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.openBox();
    //   this.$nextTick(() => {
    //      this.openBox();
    //      this.getRanges();
    //   });
  },
}
</script>
<style scoped>
.store-modal-content {
  padding: 20px;
  max-height: 70vh;
  overflow-y: auto;
}

.data_action_form {
  width: 100%;
}

.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: auto;
  overflow-y: visible;
}

.btns {
  display: flex;
  position: absolute;
  z-index: 999;
  padding-left: 10px;
  padding-top: 2px;
}

::v-deep.xunjia tr {
  height: 39px !important;
}

#smManrange {
  width: 100%;
  display: flex;
  padding-left: 83px;
  margin-bottom: 10px;
}

::v-deep #smManrange .el-form-item__content {
  width: 100% !important;
}

::v-deep #smManrange .el-textarea__inner {
  width: 76% !important;
  margin-right: 20px;
  font-size: 12px;
}

.cmContent {
  padding-left: 10px;
  width: 90%;
}

.mem-day-type-content {
  text-align: center;
  padding: 20px 0;
}

.mem-day-type-content .el-radio {
  margin: 0 20px;
  font-size: 16px;
}

.mem-day-content {
  max-height: 400px;
  overflow-y: auto;
}

.mem-day-content p {
  margin-bottom: 15px;
  font-weight: bold;
  color: #333;
}

.mem-day-content .el-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.mem-day-content .el-checkbox {
  margin-right: 15px;
  margin-bottom: 10px;
  min-width: 80px;
}

.mem-day-type-section {
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.mem-day-type-section h4 {
  margin-bottom: 10px;
  color: #333;
  font-size: 14px;
}

.mem-day-type-section .el-radio {
  margin-right: 20px;
  font-size: 14px;
}

.mem-day-detail-section h4 {
  margin-bottom: 15px;
  color: #333;
  font-size: 14px;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  background: #fff;
  height: 46px;
  padding: 5px 10px;
  margin-top: 20px;
  border-top: 1px solid #eee;
}
</style>
